<div class="spinner-container">
	<p-progressSpinner strokeWidth="4"></p-progressSpinner>
</div>
